import { HelpersService } from 'src/app/services/shared/helpers.service';
import { Component, OnInit } from '@angular/core';
import { MainService } from '../services/delavci/main.service';
import { Router } from '@angular/router';
import { faHeadset, faServer } from '@fortawesome/free-solid-svg-icons';
import { Constants } from '../utils/constants';
import { AppConfigServiceService } from '../services/app-config-service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HelpdeskService } from '../services/delavci/helpdesk.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public faHeadset = faHeadset;

  public faServer = faServer;
  public submitted = true;
  public API_URL;
  constructor(private mainService: MainService, private router: Router, private helpersService: HelpersService,
    private deviceService: DeviceDetectorService, private helpdeskService: HelpdeskService) {
    this.helpersService.currentHostname.subscribe( data => {
      this.API_URL = data;
    });

    this.mainService.changeHref(this.router.url);
  }

  ngOnInit() {
    this.submitted = false;
    //nastavi parametre, če je delavec vpisan! Parametri so med drugim: communicationCodeChat
    

  }


  onProdaja() {
    let isMobile = this.deviceService.isMobile();
    console.log(isMobile);
    if(isMobile) {
      this.router.navigate(['/prodaja/izbira']);
    } else {
      this.router.navigate(['/prodaja/izbira/nadzorna_plosca']);
    }
  }

}
